// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import CarouselController from "./carousel_controller";
application.register("carousel", CarouselController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import StatusDropdownController from "./status_dropdown_controller";
application.register("status-dropdown", StatusDropdownController);

import StatusButtonsController from "./status_buttons_controller";
application.register("status-buttons", StatusButtonsController);

import FormController from "./form_controller";
application.register("form", FormController);

import MultiSelectController from "./multi_select_controller";
application.register("multi-select", MultiSelectController);

import NotificationController from "./notification_controller";
application.register("notification", NotificationController);

import SortController from "./sort_controller";
application.register("sort", SortController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);

import SearchController from "./search_controller";
application.register("search", SearchController);

import CookieConsentController from "./cookie_consent_controller";
application.register("cookie-consent", CookieConsentController);

import FiltersController from "./filters_controller";
application.register("filters", FiltersController);

import TurnstileController from "./turnstile_controller";
application.register("turnstile", TurnstileController);

import PasswordValidationController from "./password_validation_controller";
application.register("password-validation", PasswordValidationController);

import DesktopSearchController from "./desktop_search_controller";
application.register("desktop-search", DesktopSearchController);

import MobileSearchController from "./mobile_search_controller";
application.register("mobile-search", MobileSearchController);
